import { gsap } from 'gsap';
import backgroundManager from '../../components/BackgroundManager';
import numberGrid from '../../components/NumberGrid';
import Menu from '../../components/Menu';
import '@lottiefiles/lottie-player';

export default {
	name: 'default',
	beforeOnce: ({ current, next, trigger }) => {
		return new Promise((resolve) => {

			if (next.namespace == 'home') {
				document.body.classList.add('hide-bg');
				numberGrid.setNumbersAbsoluteOnMobile();

				const preloadLogoAnimations = document.querySelectorAll('[data-preload-animation]');
				preloadLogoAnimations.forEach((element) => {
					element.addEventListener('complete', () => {
						document.dispatchEvent(new CustomEvent('preload-anim-done'));
					});
					element.classList.add('is-playing');
				});
			}

			gsap.set(next.container, {
				opacity: 0,
			});

			Promise.all([
				numberGrid.setToPreloader(),
				backgroundManager.checkForTransitionVideos(),
				backgroundManager.checkForVideos(next.container),
			]).then(() => {
				document.body.classList.add('body--preloaded');
				numberGrid.shuffeling = false;
				if (next.namespace == '404') {
					numberGrid.show404();
				}
				resolve();
			});
		});
	},
	once: ({ current, next, trigger }) => {
		// 
	},
	afterOnce: ({ current, next, trigger }) => {
		return new Promise((resolve) => {
			numberGrid.fromPreloaderToGrid().then(() => {
				gsap.to(next.container, {
					duration: 0.5,
					opacity: 1,
					ease: 'none',
					onBegin: () => {
						if (next.namespace == 'home') {
							numberGrid.showCentralNumbers();
							Menu.hideMenu();
						} else {
							numberGrid.hideCentralNumbers();
							Menu.showMenu();
						}
					},
					onComplete: () => {
						resolve();
						const preloadLogoAnimations = document.querySelectorAll('[data-preload-animation]');
						preloadLogoAnimations.forEach((player) => {
							player.play();
						});

						if(preloadLogoAnimations.length>0) {

							setTimeout(() => {
								document.body.classList.remove('hide-bg');
							}, 2000);

							preloadLogoAnimations[0].addEventListener('complete', () => {

								//Menu.showTicket();

								const logoDefaultAnimations = document.querySelectorAll('[data-anim="a"]');
								logoDefaultAnimations.forEach((animation) => {
									animation.classList.add('is-playing');
								});
								preloadLogoAnimations.forEach((element) => {
									element.classList.remove('is-playing');
								});
							});

						}
					},
				});
			});
		});
	},

	leave({ current, next, trigger }) {
		return new Promise((resolve) => {
			backgroundManager.destroyVideos();
			Menu.hideMenu();

			gsap.fromTo(
				current.container,
				{ opacity: 1 },
				{
					duration: 0.5,
					opacity: 0,
					ease: 'none',
					onComplete: () => {
						resolve();
					},
				}
			);
		});
	},
	afterLeave({ current, next, trigger }) {
		return new Promise((resolve) => {
			next.container.classList.add('default-transition-absolute');
			numberGrid.shuffle();
			backgroundManager.selectTransition().then(() => {
				resolve();
			});
		});
	},
	beforeEnter({ current, next, trigger }) {
		return new Promise((resolve) => {
			backgroundManager.checkForVideos(next.container).then(() => {
				resolve();
			});
		});
	},
	enter({ current, next, trigger }) {
		return new Promise((resolve) => {

			gsap.fromTo(
				next.container,
				{ opacity: 0 },
				{
					duration: 0.5,
					opacity: 1,
					ease: 'none',
					onBegin: () => {
						if (next.namespace == 'home') {
							document.dispatchEvent(new CustomEvent('preload-anim-done'));
							numberGrid.showCentralNumbers();
							numberGrid.setNumbersAbsoluteOnMobile();
							Menu.hideMenu();
							Menu.showTicket();
						} else {
							numberGrid.hideCentralNumbers();
							numberGrid.setNumbersFixedOnMobile();
							Menu.showMenu();
						}
					},
					onComplete: () => {
						backgroundManager.endTransition();
						resolve();
					},
				}
			);
		});
	},
	after({ current, next, trigger }) {
		next.container.classList.remove('default-transition-absolute');
		numberGrid.shuffeling = false;
		if (next.namespace == '404') {
			numberGrid.show404();
		}
	},
};
